const HTML_MARKER_PREFIX = '```html';
const CODE_MARKER_SUFFIX = '```';

/**
 * Removes HTML markers and newlines from the input text.
 * Used for cleaning streaming responses in block editor mode.
 *
 * @param text - The input text to clean
 * @returns The cleaned text without HTML markers and newlines
 * @throws {Error} If the input is null or undefined
 */
export const removeUnnecessaryCharacters = (text: string) => {
  return text
    .replace(new RegExp(`^${HTML_MARKER_PREFIX}`), '')
    .replace(new RegExp(`${CODE_MARKER_SUFFIX}$`), '')
    .replace(/\n/g, '');
};
